const validationRules = {
    // Create account form validation rules
    firstName: {
        required: true,
        requiredMsg : 'Field cannot be left blank',
        pattern: /^[A-Za-z ]+$/,
        message: "First name should only contain letters.",
    },
    lastName: {
        required: true,
        requiredMsg : 'Field cannot be left blank',
        pattern: /^[A-Za-z ]+$/,
        message: "Last name should only contain letters.",
    },
    email: {
        required: true,
        requiredMsg : 'Field cannot be left blank',
        // pattern: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
        pattern: /^[^\s@]+(\.[^\s@]+)*@[^\s@]+(\.[^\s@]+)+$/,
        message: "Please enter a valid email address.",
    },
    mobileNumber: {
        required: true,
        requiredMsg : 'Field cannot be left blank',
        pattern: /^[0-9]{10}$/,
        message: "Please enter a valid mobile number.",
    },
    password: {
        required: true,
        requiredMsg : 'Field cannot be left blank',
        pattern: /^[0-9]+$/,
        message: "Please enter a valid Password.",
    },
    userName: {
        required: true,
        requiredMsg : 'Field cannot be left blank',
        pattern: /^\S+@\S+$/i,
        message: "Please enter a valid email address.",
    },

    // Inquery form validation rules
    indianPhone: {
        required: true,
        requiredMsg : 'Phone number is required',
        pattern: /^[1-9]\d{9}$/,
        message: "Invalid phone number.",
    },

    foreignPhone: {
        required: true,
        requiredMsg : 'Phone number is required',
        pattern: /^\d{7,10}$/,
        message: "Invalid phone number.",
    },

    organizationName: {
        required: true,
        requiredMsg : 'Organisation name is required',
        pattern: /^[A-Za-z0-9][A-Za-z0-9 ]*$/,
        message: "Invalid Organisation name.",
    },
    
};

export default validationRules;